<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint"
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <!-- The code is recorded in the existing content: it can't be changed. -->

        <trax-ui-input type="text" icon="text_fields" :placeholder="codePlaceholder"
            v-model="form.code" :error="errors.code" :disabled="isUpdate" required="1">
        </trax-ui-input>

        <div class="trax-form-notice text-danger">
            {{ lang.polaris.settings.aircraft_code_notice }}
        </div>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <!-- Items are never deleted: they are disabled to leave the select lists. -->

        <trax-ui-toggle :text="lang.polaris.settings.aircraft_enabled" v-model="form.active">
        </trax-ui-toggle>

        <div class="trax-form-notice trax-form-notice-toggle text-warning">
            {{ lang.polaris.settings.aircraft_delete_notice }}
        </div>

    </trax-ui-ajax-form-in-modal>

</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint', 'codePrefix'],

        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                props: {
                    id: { source:'id' },
                    code: { source:'code' },
                    name: { source:'name' },
                    active: { source:'active', default:true }
                },
                titles: {
                    new: lang.polaris.settings.new_aircraft,
                    update: lang.polaris.settings.aircraft_update
                }
            }
        },

        computed: {

            isUpdate() {
                return this.form.id != undefined;
            },

            codePlaceholder() {
                if (this.isUpdate) {
                    return this.lang.polaris.settings.aircraft_code;
                }
                return this.lang.polaris.settings.aircraft_code + ' (' + this.codePrefix + '...)';
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
